import { message as antMessage } from 'antd';

// Configure message globally
antMessage.config({
  top: 80,
  duration: 4,
  maxCount: 3,
  getContainer: () => document.body,
});

/**
 * Show success message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds
 */
export const showSuccess = (content, duration = 4) => {
  return antMessage.success({
    content,
    duration,
  });
};

/**
 * Show error message
 * @param {string|object} content - Message content or error object
 * @param {number} duration - Duration in seconds
 */
export const showError = (content, duration = 4) => {
  // Handle error object
  let message = content;
  if (typeof content === 'object' && content !== null) {
    message = content.message || content.msg || 'Có lỗi xảy ra';
  }

  // Ensure message is a string
  if (typeof message !== 'string') {
    message = 'Có lỗi xảy ra';
  }

  return antMessage.error({
    content: message,
    duration,
  });
};

/**
 * Show info message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds
 */
export const showInfo = (content, duration = 4) => {
  return antMessage.info({
    content,
    duration,
    style: {
      marginTop: '20vh',
    },
  });
};

/**
 * Show warning message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds
 */
export const showWarning = (content, duration = 4) => {
  return antMessage.warning({
    content,
    duration,
    style: {
      marginTop: '20vh',
    },
  });
};

/**
 * Show loading message
 * @param {string} content - Message content
 * @param {number} duration - Duration in seconds (0 for infinite)
 */
export const showLoading = (content, duration = 0) => {
  return antMessage.loading({
    content,
    duration,
    style: {
      marginTop: '20vh',
    },
  });
};

/**
 * Destroy all messages
 */
export const destroyAll = () => {
  antMessage.destroy();
};

export default {
  success: showSuccess,
  error: showError,
  info: showInfo,
  warning: showWarning,
  loading: showLoading,
  destroy: destroyAll,
};

